import React from 'react';
import { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import * as additionalPaymentActions from '../../Redux/Actions/additionalPayments';
import StatusLog from '../../utils/statusLog';

const AdditionalPaymentLogs = ({ t, showModal, handleClose, id }) => {

    const [statusLogs, setStatusLogs] = useState([]);

    useEffect(() => {
        additionalPaymentActions.statusLogs(id).then(res => {
            if(res?.data) {
                setStatusLogs(res?.data);
            }
        }).catch((err) => {
            console.log(err);
        })
    }, []);

    return (
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ width: '700px'}}>
                        <div className="modal-header">
                            <h5 className="modal-title">{t("additionalPayments.statusInfo")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleClose}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="card">
                                <StatusLog t={t} statusLog={statusLogs}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
}

export default AdditionalPaymentLogs;
